<h2 mat-dialog-title>Month lock · {{ plantName ?? 'no plant' }}</h2>

<mat-dialog-content>
  @if (status(); as s) {
    <dl class="lock-status__summary">
      <dt>RED start month</dt>
      <dd>{{ s.startMonth ?? 'none' }}</dd>
      <dt>Locked through</dt>
      <dd>{{ s.lockedThrough ?? 'nothing locked yet' }}</dd>
      <dt>{{ s.lockedMonth ? 'Next lock' : 'First lock' }}</dt>
      <dd>{{ s.nextLock ? s.nextLock.month + ' locks on ' + s.nextLock.on : '—' }}</dd>
    </dl>

    <table class="lock-status__months">
      <thead>
        <tr>
          <th scope="col">Month</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        @for (row of s.rows; track row.month) {
          <tr [class.lock-status__row--locked]="row.status === 'locked_reviewed'">
            <td class="lock-status__month">{{ row.month }}</td>
            <td>
              <span class="lock-status__status">
                <mat-icon aria-hidden="true">{{ icon(row.status) }}</mat-icon>
                {{ label(row.status) }}
                @if (row.editableUntil) {
                  <span class="lock-status__muted">until {{ row.editableUntil }}</span>
                }
                @if (version(row.month); as v) {
                  @if (v.version !== null) {
                    <span class="lock-status__muted">v{{ v.version }}</span>
                  }
                  @if (v.pendingProposal) {
                    <span class="lock-status__chip lock-status__chip--warn">proposal pending</span>
                  }
                }
                @if (row.unlockedForYou) {
                  <span class="lock-status__chip">unlocked for you</span>
                }
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (s.olderNote) {
      <p class="lock-status__muted">{{ s.olderNote }}</p>
    }
    <p class="lock-status__muted">{{ s.editNote }}</p>

    <h3 class="lock-status__heading">Open unlocks on this plant</h3>
    @if (overview(); as o) {
      @for (u of o.unlocks; track u.id) {
        <p class="lock-status__unlock">
          <strong>{{ u.month }}</strong> by {{ u.openedBy ?? 'unknown' }}, until {{ time(u.expiresAt) }}
          @if (u.delegates.length) {
            <span class="lock-status__muted">(also {{ u.delegates.join(', ') }})</span>
          }
          <span class="lock-status__muted lock-status__reason">{{ u.reason }}</span>
        </p>
      } @empty {
        <p class="lock-status__muted">None.</p>
      }
    } @else {
      <p class="lock-status__muted">Loading…</p>
    }
  } @else {
    <p class="lock-status__muted">
      {{ plantId ? 'Loading the month lock…' : 'Open a single plant to see its month lock.' }}
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" mat-dialog-close>Close</button>
</mat-dialog-actions>
